import {
  getLeoUuid,
  LeoUUID,
  getObject,
  getOptionalObject,
} from "@surya-digital/leo-ts-types";
import { SurveyLocalizedText, SurveyLocalizedTextDTO } from "../assets/surveyLocalizedText";
import { QuestionViewTypeV1 } from "./questionViewTypeV1";


export namespace QuestionViewResultEnums {
  export namespace Version {
    export interface Version1DTO {
      case: string;
      questionViewTypeV1: QuestionViewTypeV1.QuestionViewTypeV1DTO;
    }
    
    export class Version1 {
      readonly isVersionVersion1: boolean = true;
    
      readonly questionViewTypeV1: QuestionViewTypeV1.QuestionViewTypeV1;
    
    
      constructor(
      questionViewTypeV1: QuestionViewTypeV1.QuestionViewTypeV1
      ) {
        this.questionViewTypeV1 = questionViewTypeV1;
      }
    
      static fromDTO(dto: Version1DTO): Version1 {
        const questionViewTypeV1 = QuestionViewTypeV1.fromDTO(getObject(dto, "questionViewTypeV1", InvalidQuestionViewResultVersionVersion1QuestionViewTypeV1Error));
        return new Version1(
          questionViewTypeV1
        );
      }
    
      toDTO(): Version1DTO {
        const dto: Version1DTO = {
          case: "VERSION_1",
            questionViewTypeV1: this.questionViewTypeV1.toDTO()
        };
        return dto;
      }
      }
    
    Version1.prototype.toString = function toString(): string {
      return `Version.VERSION_1(questionViewTypeV1='${this.questionViewTypeV1}')`;
    };
    
  
    export type Version = Version1;
  
    export type VersionDTO = Version1DTO;
  
    export const fromDTO = (dto: VersionDTO): Version => {
      switch (dto.case) {
        case "VERSION_1":
            return Version1.fromDTO(dto as Version1DTO);
        default:
          throw new InvalidQuestionViewResultVersionError(
              `Case ${dto.case} is not valid case of Version.`
          );
      }
    };
  }
  
}
export interface QuestionViewResultDTO {
  surveyQuestionViewId: string;
  question?: SurveyLocalizedTextDTO | null;
  version: QuestionViewResultEnums.Version.VersionDTO;
}

export class QuestionViewResult {
  readonly isQuestionViewResultQuestionViewResult: boolean = true;

  readonly surveyQuestionViewId: LeoUUID;
  readonly question: SurveyLocalizedText | null;
  readonly version: QuestionViewResultEnums.Version.Version;


  constructor(
  surveyQuestionViewId: LeoUUID, 
  question: SurveyLocalizedText | null = null, 
  version: QuestionViewResultEnums.Version.Version
  ) {
    this.surveyQuestionViewId = surveyQuestionViewId;
    this.question = question;
    this.version = version;
  }

  static fromDTO(dto: QuestionViewResultDTO): QuestionViewResult {
    const surveyQuestionViewId = getLeoUuid(dto, "surveyQuestionViewId", InvalidQuestionViewResultSurveyQuestionViewIdError);
    let question = getOptionalObject(dto, "question");
    if(question !== undefined && question !== null) {
      question = SurveyLocalizedText.fromDTO(getObject(dto, "question", InvalidQuestionViewResultQuestionError));
    }
    const version = QuestionViewResultEnums.Version.fromDTO(getObject(dto, "version", InvalidQuestionViewResultVersionError));
    return new QuestionViewResult(
      surveyQuestionViewId,
      question,
      version
    );
  }

  toDTO(): QuestionViewResultDTO {
    const dto: QuestionViewResultDTO = {
        surveyQuestionViewId: this.surveyQuestionViewId.toDTO(),
        version: this.version.toDTO()
    };
    if (this.question !== undefined && this.question !== null){
      dto.question = this.question.toDTO();
    }
    return dto;
  }
  }

QuestionViewResult.prototype.toString = function toString(): string {
  return `QuestionViewResult(surveyQuestionViewId='${this.surveyQuestionViewId}',question='${this.question}',version='${this.version}')`;
};

export class InvalidQuestionViewResultError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewResultError";
  }
}
export class InvalidQuestionViewResultSurveyQuestionViewIdError extends InvalidQuestionViewResultError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewResultSurveyQuestionViewIdError";
  }
}

export class InvalidQuestionViewResultQuestionError extends InvalidQuestionViewResultError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewResultQuestionError";
  }
}

export class InvalidQuestionViewResultVersionError extends InvalidQuestionViewResultError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewResultVersionError";
  }
}

export class InvalidQuestionViewResultVersionVersion1Error extends InvalidQuestionViewResultVersionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewResultVersionVersion1Error";
  }
}

export class InvalidQuestionViewResultVersionVersion1QuestionViewTypeV1Error extends InvalidQuestionViewResultVersionVersion1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewResultVersionVersion1QuestionViewTypeV1Error";
  }
}
